import {
  createFrontendModule,
  coreExtensionData,
} from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { AppIcons } from '../utils/icons';
import searchPlugin from '@backstage/plugin-search/alpha';
import { makeStyles } from '@material-ui/core/styles';

const useSearchPageStyles = makeStyles((theme) => ({
  root: {
    '& [class*="BackstageContent-root"]': {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
  },
}));

const appviaSearchNavItem = searchPlugin
  .getExtension('nav-item:search')
  .override({
    params: {
      icon: AppIcons.search as IconComponent,
    },
  });

const appviaSearchPage = searchPlugin.getExtension('page:search').override({
  factory(originalFactory, _context) {
    const originalContainer = originalFactory();
    const originalElement = originalContainer.get(
      coreExtensionData.reactElement,
    );

    const WrappedSearchPage = () => {
      const classes = useSearchPageStyles();
      return <div className={classes.root}>{originalElement}</div>;
    };

    return [
      coreExtensionData.reactElement(<WrappedSearchPage />),
      ...Array.from(originalContainer).filter(
        item => item.id !== 'core.reactElement',
      ),
    ];
  },
});

export const appviaSearchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [appviaSearchNavItem, appviaSearchPage],
});
